"use client"
import { useQualityChanges } from "@/hooks/use-quality-presentations"


import { Loader2 } from "lucide-react"

import { Button } from "@/components/ui/button"
import { useFindImprovementsNowMutation } from "@/hooks/mutations/conversation-quality"
import { useFindImprovementsCompletion, useFindImprovementsStatusQuery } from "@/hooks/queries/conversation-quality"
import { usePermissions } from "@/hooks/use-permissions"
import { MESSAGING_AGENTS_PERMISSIONS } from "@/lib/auth/permissions.constants"
import { FIND_NOW_NO_PERMISSION, findNowLine } from "@/lib/conversation-quality/change-display"
import type { FindNowReport } from "@/lib/conversation-quality/suggestions/schema"

/** Drafts from the last seven days now, within the weekly allowance; its line says why it can't be pressed. */
export function FindImprovementsNow({ agentId, timezone }: { agentId: string | null; timezone: string }) {
  const { FIND_NOW_LABEL } = useQualityChanges()

  const { can } = usePermissions()
  const canRun = can(MESSAGING_AGENTS_PERMISSIONS.MANAGE)
  const input = { agentId }
  const { data } = useFindImprovementsStatusQuery(input)
  const press = useFindImprovementsNowMutation(timezone)
  useFindImprovementsCompletion(data)

  const line = stateLine(canRun, data, timezone)

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={!canRun || data?.current.state !== "available" || press.isPending}
        onClick={() => press.mutate(input)}
      >
        {data?.current.state === "running" && <Loader2 className="size-4 animate-spin" aria-hidden />}
        <span>{FIND_NOW_LABEL}</span>
      </Button>
      {line && <p className="min-w-[12rem] flex-1 text-xs text-muted-foreground">{line}</p>}
    </div>
  )
}

function stateLine(canRun: boolean, data: FindNowReport | undefined, timezone: string): string | null {
  if (!canRun) return FIND_NOW_NO_PERMISSION
  return data ? findNowLine(data.current, timezone) : null
}
